import React from 'react';
import { SectionHeader } from './SectionHeader';
export function FederalRegulations() {
  return <section className="py-16 bg-white" data-id="element-128">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <SectionHeader id="Federal-Regulations" number="01" title="THE FEDERAL REGULATIONS" data-id="element-130" />

        <div className="bg-legal-light p-8 rounded-lg border border-legal-border prose prose-lg max-w-none text-legal-gray" data-id="element-131">
          <p data-id="element-132">
            The Federal Motor Carrier Safety Regulations (FMCSR) are
            comprehensive rules designed to reduce crashes, injuries, and
            fatalities involving large trucks and buses. These regulations apply
            to all employers, employees, and commercial motor vehicles that
            transport property or passengers in interstate commerce.
          </p>
          <p data-id="element-133">
            Under Title 49 of the Federal Code, motor carriers are held to a
            strict standard of safety. It is the responsibility of the motor
            carrier to ensure that all drivers are fully trained, qualified, and
            compliant with the FMCSR. When a trucking company fails to adhere to
            these federal standards, they can be held liable for the devastating
            accidents that result.
          </p>
          <p data-id="element-134">
            The regulations cover a wide array of safety protocols, including
            driver qualifications, hours of service, vehicle maintenance, and
            cargo securement. Below is a detailed breakdown of the specific
            rules that frequently play a role in commercial vehicle litigation.
          </p>
        </div>
      </div>
    </section>;
}